import { Button, Logo } from '#ui';

/**
 * Reusable error fallback component for panel views
 */
export function TripPanelErrorFallback({
  error,
  resetErrorBoundary,
  viewName,
}: {
  error: Error;
  resetErrorBoundary: () => void;
  viewName: string;
}) {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-4 p-8">
      <div className="mx-auto max-w-sm text-left">
        <Logo variant="symbol" width={24} />
        <h1 className="mt-4 text-2xl font-semibold font-display">Something went wrong</h1>
        <p className="mt-2 mb-6 text-muted-foreground">
          We encountered an error while loading the {viewName}. This might be a temporary issue.
        </p>

        {process.env.NODE_ENV === 'development' && (
          <details className="mb-6 text-left">
            <summary className="cursor-pointer text-sm text-muted-foreground hover:text-foreground">
              Error Details (Development)
            </summary>
            <pre className="mt-2 rounded bg-muted p-3 text-xs text-muted-foreground overflow-auto">
              {error.message}
              {error.stack && `\n\n${error.stack}`}
            </pre>
          </details>
        )}

        <div className="flex flex-col gap-3 sm:flex-row">
          <Button onClick={resetErrorBoundary}>Try again</Button>
        </div>
      </div>
    </div>
  );
}
